import script from "./BaseTabList.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTabList.vue?vue&type=script&setup=true&lang=js"

import "./BaseTabList.vue?vue&type=style&index=0&id=ea8f7a12&lang=scss"

const __exports__ = script;

export default __exports__